import {connect} from "react-redux";
import {updateSession} from "../../redux/actions";
import {API_URL} from "../../constants";
import {SessionModal} from "./SessionModal";

class EditSessionModal extends SessionModal {
    handleClose() {
        this.setState((state, props) => ({
            selectedSessionType: this.props.selectedSessionType,
            newSession: this.props.session,
            alertShow: false,
            alertMessage: ''
        }));

        // Call to parent's callback
        this.props.handleClose();
    }

    handleSave() {
        const sessionId = this.props.session.id;

        const data = {
            type: this.state.selectedSessionType,
            data: this.state.newSession
        };

        fetch(API_URL + '/sessions/' + sessionId, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + this.props.user.api_token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data),
        }).then((response) => {
            if (!response.ok) throw Error(response.statusText);    // Will go to .catch
            return response.json()
        }).then(data => {
            /* Update paper session in the frontend */
            this.props.updateSession(sessionId, data);

            this.props.handleClose();
        }).catch((error) => {
            this.showAlert(error.toString());
        })
    }
}

export default connect(
    null,
    {updateSession}
)(EditSessionModal)
